import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import ReactDOM from 'react-dom/client';
// catalogApiDedup patches `queryEntities`; catalogApiTechDocsFilter patches
// both `queryEntities` and `getEntityFacets`. Pull them in before `./App` —
// the app boots the catalog API and starts issuing requests as soon as it
// renders. They wrap independent concerns and compose in either order;
// `catalogApiTechDocsFilter.test.ts` covers them running together.
import './catalogApiDedup'; // Deduplicate simultaneous identical catalog API calls
import './catalogApiTechDocsFilter'; // OR the TechDocs annotations server-side
import app from './App';

if (process.env.NODE_ENV === 'development') {
  void import('react-grab').catch(() => {});
}

// Suppress benign ResizeObserver loop error that occurs with react-use-measure
// This error is harmless and occurs when a resize triggers another resize in the same frame
// See: https://github.com/WICG/resize-observer/issues/38
const resizeObserverError = 'ResizeObserver loop';
const originalError = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes(resizeObserverError)) {
    return true; // Suppress the error
  }
  return originalError ? originalError(message, ...args) : false;
};

// Also handle unhandled promise rejections for this error
window.addEventListener('error', (event) => {
  if (event.message?.includes(resizeObserverError)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(app);
